module.exports = __webpack_public_path__ + "static/vicmap-aerial-icon-e73f30936cd13ad768b44cd7faa8ea95.png";